var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "basic-modal",
    {
      attrs: { "aria-label": "New Wiki", role: "dialog" },
      on: { hide: _vm.close },
      model: {
        value: _vm.opened,
        callback: function ($$v) {
          _vm.opened = $$v
        },
        expression: "opened",
      },
    },
    [
      _c(
        "div",
        { attrs: { slot: "header" }, slot: "header" },
        [
          _c("basic-modal-close-button", { ref: "closeButton" }),
          _vm._v(" "),
          _c("h3", { staticClass: "modal-title" }, [
            _vm._v("Update access link"),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "alert alert-warning" }, [
        _vm._v(
          "\n        Attention: this link will be valid for the specified term from today's date.\n    "
        ),
      ]),
      _vm._v(" "),
      _c("div", [
        _c(
          "form",
          {
            attrs: { action: "#" },
            on: {
              submit: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.createLink.apply(null, arguments)
              },
            },
          },
          [
            _c("div", { staticClass: "row margin-15-top" }, [
              _c("div", { staticClass: "col-sm-12" }, [
                _c("div", [
                  _c("strong", [_vm._v("Link expires in:")]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.validityTerm,
                          expression: "validityTerm",
                        },
                      ],
                      staticClass: "form-control",
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.validityTerm = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                      },
                    },
                    _vm._l(_vm.accessLinkPossibleTerms, function (term) {
                      return _c(
                        "option",
                        { key: term.val, domProps: { value: term.val } },
                        [
                          _vm._v(
                            _vm._s(term.name) + "\n                            "
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
              ]),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
        _c(
          "button",
          { staticClass: "btn btn-mm btn-default", on: { click: _vm.close } },
          [_vm._v("Cancel")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-mm btn-green",
            on: { click: _vm.createLink },
          },
          [_vm._v("Update")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }